var _g, _g2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _path3, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOctopus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 340,
    viewBox: "0 0 370 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 136.995C33.3206 136.995 34.2429 136.074 34.2429 134.937C34.2429 133.801 33.3206 132.88 32.1829 132.88C31.0452 132.88 30.1229 133.801 30.1229 134.937C30.1229 136.074 31.0452 136.995 32.1829 136.995Z",
    fill: "#B28B67"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.628 37.0808C280.129 37.0808 281.345 35.8658 281.345 34.3671C281.345 32.8683 280.129 31.6533 278.628 31.6533C277.128 31.6533 275.911 32.8683 275.911 34.3671C275.911 35.8658 277.128 37.0808 278.628 37.0808Z",
    fill: "#CCCCCC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.038 208.501C332.468 208.315 334.286 206.196 334.099 203.77C333.912 201.343 331.791 199.527 329.361 199.714C326.932 199.901 325.114 202.019 325.301 204.446C325.488 206.872 327.609 208.688 330.038 208.501Z",
    fill: "#B28B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.956 145.314C325 145.314 325.846 144.469 325.846 143.427C325.846 142.385 325 141.54 323.956 141.54C322.913 141.54 322.067 142.385 322.067 143.427C322.067 144.469 322.913 145.314 323.956 145.314Z",
    fill: "#B28B67"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.361 106.447C103.991 106.447 105.313 105.127 105.313 103.498C105.313 101.87 103.991 100.55 102.361 100.55C100.73 100.55 99.4084 101.87 99.4084 103.498C99.4084 105.127 100.73 106.447 102.361 106.447Z",
    fill: "#B28B67"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.181 118.355C286.225 118.355 287.071 117.51 287.071 116.468C287.071 115.425 286.225 114.58 285.181 114.58C284.138 114.58 283.292 115.425 283.292 116.468C283.292 117.51 284.138 118.355 285.181 118.355Z",
    fill: "#B28B67"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter4_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.936 271.804C151.816 270.152 151.717 266.97 149.714 264.695C147.711 262.421 144.564 261.916 142.684 263.568C140.803 265.219 140.903 268.402 142.905 270.676C144.908 272.951 148.055 273.456 149.936 271.804Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.72 150.17C291.651 146.019 289.037 141.899 284.88 140.969C280.724 140.038 276.599 142.65 275.668 146.801C274.736 150.953 277.351 155.073 281.507 156.003C285.664 156.934 289.789 154.322 290.72 150.17Z",
    fill: "#FFDBA6"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.628 137.594C284.23 137.28 282.785 137.244 281.373 137.488C279.962 137.733 278.613 138.253 277.403 139.019C276.193 139.785 275.146 140.782 274.323 141.952C273.499 143.123 272.915 144.444 272.603 145.841C271.289 151.706 277.607 173.383 277.607 173.383C277.607 173.383 292.57 156.485 293.884 150.62C294.201 149.223 294.239 147.778 293.996 146.366C293.752 144.954 293.232 143.605 292.465 142.394C291.698 141.184 290.699 140.137 289.526 139.313C288.352 138.49 287.028 137.905 285.628 137.594ZM282.084 153.407C281.386 153.251 280.73 152.948 280.158 152.521C279.586 152.093 279.111 151.548 278.765 150.924C278.418 150.299 278.208 149.609 278.149 148.897C278.089 148.186 278.181 147.47 278.418 146.797C278.838 145.791 279.55 144.934 280.462 144.336C281.374 143.738 282.445 143.427 283.535 143.443C284.418 143.496 285.271 143.778 286.011 144.262C286.75 144.745 287.35 145.414 287.751 146.201C288.152 146.988 288.339 147.866 288.296 148.747C288.252 149.629 287.978 150.484 287.501 151.228C286.946 152.111 286.129 152.798 285.163 153.195C284.198 153.591 283.133 153.677 282.116 153.439L282.084 153.407Z",
    fill: "#FEFAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.628 137.594C284.23 137.28 282.785 137.244 281.373 137.488C279.962 137.733 278.613 138.253 277.403 139.019C276.193 139.785 275.146 140.782 274.323 141.952C273.499 143.123 272.915 144.444 272.603 145.841C271.289 151.706 277.607 173.383 277.607 173.383C277.607 173.383 292.57 156.485 293.884 150.62C294.201 149.223 294.239 147.778 293.996 146.366C293.752 144.954 293.232 143.605 292.465 142.394C291.698 141.184 290.699 140.137 289.526 139.313C288.352 138.49 287.028 137.905 285.628 137.594ZM282.084 153.407C281.386 153.251 280.73 152.948 280.158 152.521C279.586 152.093 279.111 151.548 278.765 150.924C278.418 150.299 278.208 149.609 278.149 148.897C278.089 148.186 278.181 147.47 278.418 146.797C278.838 145.791 279.55 144.934 280.462 144.336C281.374 143.738 282.445 143.427 283.535 143.443C284.418 143.496 285.271 143.778 286.011 144.262C286.75 144.745 287.35 145.414 287.751 146.201C288.152 146.988 288.339 147.866 288.296 148.747C288.252 149.629 287.978 150.484 287.501 151.228C286.946 152.111 286.129 152.798 285.163 153.195C284.198 153.591 283.133 153.677 282.116 153.439L282.084 153.407Z",
    stroke: "#572148",
    strokeWidth: 0.446371,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6416 182.764C43.5889 182.764 45.9781 180.378 45.9781 177.434C45.9781 174.49 43.5889 172.104 40.6416 172.104C37.6943 172.104 35.3051 174.49 35.3051 177.434C35.3051 180.378 37.6943 182.764 40.6416 182.764Z",
    fill: "#FFDBA6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4523 170.03C37.5013 170.31 36.615 170.774 35.8439 171.396C35.0727 172.018 34.4319 172.786 33.9581 173.656C33.4844 174.525 33.1869 175.48 33.0827 176.465C32.9785 177.449 33.0696 178.445 33.3509 179.394C34.535 183.388 45.6541 194.364 45.6541 194.364C45.6541 194.364 49.0118 179.119 47.8277 175.125C47.5476 174.175 47.0828 173.29 46.4599 172.52C45.837 171.75 45.0682 171.109 44.1974 170.636C43.3267 170.163 42.3711 169.866 41.3853 169.762C40.3995 169.658 39.4028 169.749 38.4523 170.03ZM41.6315 180.788C41.1572 180.926 40.659 180.963 40.1695 180.895C39.68 180.828 39.2104 180.657 38.7915 180.396C38.3725 180.134 38.0137 179.787 37.7386 179.377C37.4635 178.967 37.2783 178.504 37.1952 178.017C37.1097 177.268 37.251 176.51 37.6008 175.841C37.9506 175.173 38.493 174.624 39.1578 174.266C39.7076 174.011 40.3141 173.902 40.9185 173.95C41.5228 173.998 42.1044 174.202 42.6066 174.541C43.1088 174.881 43.5145 175.344 43.7842 175.886C44.0539 176.429 44.1784 177.032 44.1456 177.636C44.1087 178.358 43.8463 179.05 43.3954 179.615C42.9444 180.181 42.3276 180.59 41.6315 180.788Z",
    fill: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4523 170.03C37.5013 170.31 36.615 170.774 35.8439 171.396C35.0727 172.018 34.4319 172.786 33.9581 173.656C33.4844 174.525 33.1869 175.48 33.0827 176.465C32.9785 177.449 33.0696 178.445 33.3509 179.394C34.535 183.388 45.6541 194.364 45.6541 194.364C45.6541 194.364 49.0118 179.119 47.8277 175.125C47.5476 174.175 47.0828 173.29 46.4599 172.52C45.837 171.75 45.0682 171.109 44.1974 170.636C43.3267 170.163 42.3711 169.866 41.3853 169.762C40.3995 169.658 39.4028 169.749 38.4523 170.03ZM41.6315 180.788C41.1572 180.926 40.659 180.963 40.1695 180.895C39.68 180.828 39.2104 180.657 38.7915 180.396C38.3725 180.134 38.0137 179.787 37.7386 179.377C37.4635 178.967 37.2783 178.504 37.1952 178.017C37.1097 177.268 37.251 176.51 37.6008 175.841C37.9506 175.173 38.493 174.624 39.1578 174.266C39.7076 174.011 40.3141 173.902 40.9185 173.95C41.5228 173.998 42.1044 174.202 42.6066 174.541C43.1088 174.881 43.5145 175.344 43.7842 175.886C44.0539 176.429 44.1784 177.032 44.1456 177.636C44.1087 178.358 43.8463 179.05 43.3954 179.615C42.9444 180.181 42.3276 180.59 41.6315 180.788Z",
    stroke: "#572148",
    strokeWidth: 0.309484,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.268 25.8613C109.306 25.8613 110.958 24.2111 110.958 22.1755C110.958 20.1398 109.306 18.4896 107.268 18.4896C105.23 18.4896 103.578 20.1398 103.578 22.1755C103.578 24.2111 105.23 25.8613 107.268 25.8613Z",
    fill: "#FFDBA6"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.317 16.8369C106.632 16.8305 105.952 16.9589 105.317 17.2147C104.682 17.4706 104.104 17.8489 103.615 18.3281C103.126 18.8072 102.736 19.3779 102.469 20.0074C102.201 20.6369 102.059 21.313 102.053 21.9971C102.053 24.8809 107.154 34.3669 107.154 34.3669C107.154 34.3669 112.458 24.97 112.483 22.0943C112.494 20.7134 111.956 19.3847 110.987 18.3992C110.019 17.4137 108.699 16.8519 107.317 16.8369ZM107.244 24.5893C106.903 24.5838 106.567 24.5069 106.258 24.3634C105.948 24.22 105.673 24.0132 105.449 23.7566C105.225 23.5 105.057 23.1992 104.957 22.8738C104.857 22.5483 104.826 22.2055 104.867 21.8674C104.963 21.3544 105.21 20.8818 105.577 20.5107C105.945 20.1396 106.415 19.887 106.927 19.7856C107.342 19.7296 107.765 19.7816 108.154 19.9366C108.543 20.0915 108.885 20.3442 109.148 20.67C109.411 20.9959 109.585 21.384 109.653 21.7967C109.721 22.2094 109.682 22.6328 109.539 23.0259C109.369 23.4948 109.056 23.8988 108.644 24.1807C108.233 24.4627 107.743 24.6084 107.244 24.5974V24.5893Z",
    fill: "#DEF6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.317 16.8369C106.632 16.8305 105.952 16.9589 105.317 17.2147C104.682 17.4706 104.104 17.8489 103.615 18.3281C103.126 18.8072 102.736 19.3779 102.469 20.0074C102.201 20.6369 102.059 21.313 102.053 21.9971C102.053 24.8809 107.154 34.3669 107.154 34.3669C107.154 34.3669 112.458 24.97 112.483 22.0943C112.494 20.7134 111.956 19.3847 110.987 18.3992C110.019 17.4137 108.699 16.8519 107.317 16.8369ZM107.244 24.5893C106.903 24.5838 106.567 24.5069 106.258 24.3634C105.948 24.22 105.673 24.0132 105.449 23.7566C105.225 23.5 105.057 23.1992 104.957 22.8738C104.857 22.5483 104.826 22.2055 104.867 21.8674C104.963 21.3544 105.21 20.8818 105.577 20.5107C105.945 20.1396 106.415 19.887 106.927 19.7856C107.342 19.7296 107.765 19.7816 108.154 19.9366C108.543 20.0915 108.885 20.3442 109.148 20.67C109.411 20.9959 109.585 21.384 109.653 21.7967C109.721 22.2094 109.682 22.6328 109.539 23.0259C109.369 23.4948 109.056 23.8988 108.644 24.1807C108.233 24.4627 107.743 24.6084 107.244 24.5974V24.5893Z",
    stroke: "#572148",
    strokeWidth: 0.214258,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9962 245.053C86.3825 244.562 91.1612 238.993 90.6698 232.614C90.1784 226.235 84.603 221.462 78.2166 221.953C71.8303 222.444 67.0516 228.013 67.543 234.392C68.0344 240.771 73.6098 245.544 79.9962 245.053Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6924 241.073C78.1937 241.189 76.6944 240.858 75.3839 240.122C74.0735 239.387 73.0108 238.28 72.3304 236.941C71.6499 235.602 71.3823 234.092 71.5613 232.601C71.7403 231.111 72.3578 229.706 73.3359 228.566C74.3139 227.426 75.6085 226.601 77.0559 226.196C78.5033 225.791 80.0385 225.824 81.4673 226.29C82.896 226.757 84.1543 227.636 85.0827 228.817C86.0112 229.997 86.5683 231.427 86.6834 232.924C86.8378 234.93 86.1881 236.916 84.8771 238.444C83.5661 239.972 81.7012 240.918 79.6924 241.073Z",
    fill: "#B28B67"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6835 320.379H86.3672V319.383C86.3695 319.739 86.4798 320.087 86.6835 320.379Z",
    fill: "#572148"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.141 319.383V320.379H284.801C285.016 320.091 285.135 319.742 285.141 319.383Z",
    fill: "#572148"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.141 294.181V319.383C285.135 319.742 285.016 320.091 284.8 320.379C280.648 326.592 237.883 331.477 185.758 331.477C133.634 331.477 90.8687 326.617 86.6838 320.379C86.4744 320.088 86.3584 319.741 86.3513 319.383V294.181C86.3513 287.49 130.86 282.03 185.758 282.03C240.657 282.03 285.141 287.49 285.141 294.181Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.141 294.181V319.383C285.135 319.742 285.016 320.091 284.8 320.379C280.648 326.592 237.883 331.477 185.758 331.477C133.634 331.477 90.8687 326.617 86.6838 320.379C86.4744 320.088 86.3584 319.741 86.3513 319.383V294.181C86.3513 287.49 130.86 282.03 185.758 282.03C240.657 282.03 285.141 287.49 285.141 294.181Z",
    stroke: "#572148",
    strokeWidth: 0.51779,
    strokeMiterlimit: 10
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.894 302.606C235.766 302.606 275.385 298.413 275.385 293.242C275.385 288.07 235.766 283.877 186.894 283.877C138.022 283.877 98.4032 288.07 98.4032 293.242C98.4032 298.413 138.022 302.606 186.894 302.606Z",
    fill: "#F6F4EF"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.052 235.314C167.253 233.499 166.625 231.942 165.65 231.834C164.675 231.726 163.722 233.11 163.521 234.924C163.321 236.739 163.949 238.297 164.924 238.404C165.899 238.512 166.852 237.128 167.052 235.314Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.325 257.026C242.526 255.211 241.898 253.653 240.923 253.546C239.948 253.438 238.995 254.822 238.794 256.636C238.594 258.451 239.222 260.009 240.197 260.116C241.172 260.224 242.125 258.84 242.325 257.026Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.801 238.606C245.001 236.792 244.373 235.234 243.398 235.126C242.423 235.019 241.471 236.403 241.27 238.217C241.069 240.031 241.697 241.589 242.672 241.697C243.647 241.804 244.6 240.421 244.801 238.606Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.274 222.333C244.217 222.064 244.574 220.423 244.072 218.667C243.57 216.912 242.398 215.708 241.455 215.977C240.512 216.246 240.155 217.887 240.657 219.642C241.159 221.398 242.331 222.602 243.274 222.333Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.961 204.156C236.803 203.654 236.725 201.976 235.787 200.409C234.85 198.843 233.407 197.98 232.565 198.483C231.723 198.985 231.801 200.663 232.738 202.23C233.676 203.797 235.119 204.659 235.961 204.156Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.873 84.1945C257.539 47.7626 247.133 16.3056 211.34 5.5527C168.041 -7.45535 120.303 22.0458 113.368 67.2316C111.908 76.7256 111.041 90.0027 118.437 111.056C122.168 121.66 132.338 134.751 141.065 141.232C162.841 157.433 136.418 168.434 104.771 162.439C89.0376 159.458 66.2722 130.531 66.2722 130.531C66.0294 130.122 65.6905 129.779 65.285 129.53C64.8794 129.282 64.4193 129.136 63.9446 129.105C63.3661 129.065 62.7861 129.157 62.2481 129.373C61.7101 129.589 61.2281 129.924 60.838 130.353C60.4479 130.781 60.16 131.293 59.9957 131.848C59.8315 132.403 59.7951 132.989 59.8895 133.56C62.4036 150.151 116.572 208.127 137.634 200.796C174.244 183.785 214.803 177.11 230.439 184.919C237.779 192.615 248.858 210.712 249.279 227.529C249.661 242.547 240.577 258.214 238.379 265.861C237.163 270.066 241.25 271.143 242.653 270.033C257.56 258.198 265.167 241.681 268.379 222.142C271.623 202.416 263.278 186.385 251.769 177.337C198.753 135.675 274.077 120.057 265.873 84.1945Z",
    fill: "url(#paint0_radial_692_38)",
    stroke: "#B03C36",
    strokeWidth: 0.595161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.289 95.8917C148.609 95.8917 153.732 90.7743 153.732 84.4616C153.732 78.1489 148.609 73.0315 142.289 73.0315C135.969 73.0315 130.845 78.1489 130.845 84.4616C130.845 90.7743 135.969 95.8917 142.289 95.8917Z",
    fill: "#1B1B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.123 94.4015C139.385 94.4015 141.219 92.5699 141.219 90.3106C141.219 88.0513 139.385 86.2197 137.123 86.2197C134.861 86.2197 133.027 88.0513 133.027 90.3106C133.027 92.5699 134.861 94.4015 137.123 94.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.373 95.8917C190.693 95.8917 195.816 90.7743 195.816 84.4616C195.816 78.1489 190.693 73.0315 184.373 73.0315C178.053 73.0315 172.929 78.1489 172.929 84.4616C172.929 90.7743 178.053 95.8917 184.373 95.8917Z",
    fill: "#1B1B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.362 254.609C156.62 220.23 181.697 191.124 192.216 179.216C180.862 173.27 151.284 161.281 146.134 174.096C139.694 190.111 131.941 225.941 138.177 250.348C144.414 274.756 169.532 297.584 162.362 254.609Z",
    fill: "url(#paint1_radial_692_38)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.012 181.201C181.509 189.127 175.247 198.139 170.439 207.933C163.659 221.704 159.085 238.594 161.38 256.481C161.999 260.747 162.246 265.06 162.118 269.369C161.948 272.698 161.413 274.618 160.91 275.598C160.726 276.012 160.438 276.372 160.074 276.643C159.711 276.914 159.284 277.087 158.834 277.146C157.381 277.22 155.947 276.788 154.779 275.922C151.672 273.954 148.177 269.879 145.111 264.703C141.888 259.28 139.524 253.391 138.104 247.246C135.411 235.03 136.482 220.408 139.183 206.945C141.883 193.481 146.174 181.257 149.791 173.999C149.888 173.813 149.993 173.626 150.107 173.448C150.748 171.731 151.275 170.127 151.729 168.636C150.25 169.752 149.06 171.204 148.258 172.873C144.276 180.852 139.807 193.684 137.009 207.641C134.211 221.599 133.076 236.917 135.898 249.708C137.358 256.059 139.796 262.145 143.124 267.749C146.247 273.022 149.856 277.267 153.156 279.357C154.545 280.358 156.242 280.84 157.95 280.718C159.482 280.491 161.194 279.398 162.508 276.781C163.764 273.976 164.432 270.943 164.47 267.87C164.617 263.328 164.362 258.782 163.708 254.285C161.51 237.314 165.857 221.688 172.078 209.035C178.298 196.381 186.635 186.353 192.353 181.168L194.721 179.005L194.413 178.819C192.506 179.345 190.686 180.148 189.012 181.201Z",
    fill: "#B03C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.666 214.252C223.293 199.304 217.531 184.797 210.456 170.921L167.366 170.573C170.797 177.32 179.759 185.786 189.077 196.552C196.3 204.943 201.763 214.697 205.143 225.236C208.523 235.775 209.75 246.885 208.753 257.906C206.652 281.779 209.264 298.41 220.585 278.272C225.951 268.6 229.339 257.961 230.555 246.971C231.77 235.981 230.788 224.859 227.666 214.252Z",
    fill: "#FC5950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.666 215.224C223.291 200.285 217.529 185.786 210.456 171.917L167.366 171.569C170.797 178.317 179.759 186.774 189.077 197.548C196.3 205.938 201.762 215.691 205.142 226.229C208.522 236.766 209.75 247.874 208.753 258.895C206.652 282.776 209.264 299.398 220.585 279.268C225.953 269.593 229.343 258.95 230.559 247.955C231.774 236.961 230.791 225.835 227.666 215.224Z",
    fill: "url(#paint2_radial_692_38)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5404 133.544C59.5966 134.696 59.8375 135.831 60.2541 136.906C65.4041 148.401 92.4598 202.376 138.112 202.376L142.849 185.956C142.849 185.956 89.6131 187.681 63.4982 135.456C63.4982 135.456 59.7594 128.611 59.5404 133.544Z",
    fill: "#FFB8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.511 179.249C214.511 179.249 242.613 176.008 252.353 211.7C259.944 239.558 239.482 270.398 239.482 270.398C239.482 270.398 237 269.823 238.168 265.343C255.792 197.637 219.596 190.922 219.596 190.922L214.511 179.249Z",
    fill: "#FFB8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.739 219.557C167.739 219.557 145.03 245.804 158.007 279.106C158.007 279.106 158.363 280.726 159.58 280.402C162.119 279.762 164.803 279.316 164.803 266.347C164.819 257.76 161.437 250.259 167.739 219.557Z",
    fill: "#FFB8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7154 156.964C72.512 156.393 72.2932 154.727 71.2268 153.245C70.1604 151.763 68.6501 151.025 67.8535 151.596C67.0569 152.168 67.2756 153.833 68.3421 155.316C69.4085 156.798 70.9188 157.536 71.7154 156.964Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1485 174.663C84.9451 174.092 84.7263 172.426 83.6599 170.944C82.5935 169.462 81.0832 168.724 80.2866 169.295C79.49 169.867 79.7087 171.532 80.7752 173.015C81.8416 174.497 83.3519 175.235 84.1485 174.663Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7775 188.156C99.4493 187.442 98.9142 185.849 97.5825 184.599C96.2507 183.349 94.6266 182.915 93.9548 183.629C93.2831 184.343 93.8181 185.935 95.1499 187.185C96.4816 188.435 98.1058 188.87 98.7775 188.156Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.708 197.423C115.154 196.55 114.196 195.17 112.568 194.34C110.94 193.511 109.259 193.546 108.813 194.419C108.368 195.291 109.326 196.671 110.954 197.501C112.582 198.33 114.263 198.295 114.708 197.423Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.72 202.609C134.793 201.632 133.375 200.729 131.552 200.593C129.73 200.458 128.193 201.139 128.12 202.116C128.047 203.094 129.465 203.996 131.288 204.132C133.11 204.268 134.647 203.586 134.72 202.609Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.809 270.062C166.011 268.248 165.384 266.69 164.409 266.581C163.434 266.473 162.48 267.856 162.278 269.67C162.077 271.485 162.703 273.043 163.678 273.151C164.653 273.259 165.607 271.876 165.809 270.062Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.834 251.701C165.846 249.875 165.06 248.391 164.079 248.384C163.098 248.378 162.294 249.853 162.282 251.678C162.271 253.504 163.057 254.988 164.038 254.995C165.018 255.001 165.823 253.526 165.834 251.701Z",
    fill: "#BA403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.547 122.6C165.541 123.92 177.633 124.423 185.298 119.692C185.603 119.507 185.946 119.392 186.301 119.355C186.656 119.317 187.015 119.358 187.353 119.475C187.69 119.592 187.998 119.781 188.254 120.03C188.51 120.279 188.708 120.581 188.834 120.915C189.815 123.41 190.553 126.909 187.933 128.586C187.933 128.586 175.655 138.518 155.006 127.185C154.456 126.937 154.017 126.494 153.776 125.942C153.534 125.39 153.507 124.767 153.699 124.196C153.891 123.624 154.289 123.145 154.815 122.85C155.341 122.555 155.958 122.466 156.547 122.6Z",
    fill: "#1B1B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.266 92.6842C180.187 92.6842 181.745 91.1283 181.745 89.209C181.745 87.2897 180.187 85.7338 178.266 85.7338C176.344 85.7338 174.786 87.2897 174.786 89.209C174.786 91.1283 176.344 92.6842 178.266 92.6842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.133,
    y: 259.778,
    width: 166.26,
    height: 67.236,
    fill: "url(#pattern0)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.166 8.99619L15.198 36.3794C14.6193 36.7398 14.4427 37.5006 14.8035 38.0786L42.408 82.298C42.7688 82.876 43.5305 83.0524 44.1092 82.692L88.0771 55.3088C88.6558 54.9484 88.8325 54.1876 88.4716 53.6096L60.8672 9.39021C60.5063 8.81218 59.7447 8.63577 59.166 8.99619Z",
    fill: "#FFB8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.166 8.99619L15.198 36.3794C14.6193 36.7398 14.4427 37.5006 14.8035 38.0786L42.408 82.298C42.7688 82.876 43.5305 83.0524 44.1092 82.692L88.0771 55.3088C88.6558 54.9484 88.8325 54.1876 88.4716 53.6096L60.8672 9.39021C60.5063 8.81218 59.7447 8.63577 59.166 8.99619Z",
    stroke: "black",
    strokeWidth: 0.470976,
    strokeMiterlimit: 10
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2324 10.5204L16.3493 36.4688C15.7935 36.8131 15.6225 37.5421 15.9672 38.0972L42.5102 80.84C42.8549 81.3951 43.5849 81.5659 44.1406 81.2216L86.0238 55.2733C86.5795 54.929 86.7506 54.1999 86.4059 53.6448L59.8628 10.9021C59.5181 10.347 58.7881 10.1761 58.2324 10.5204Z",
    fill: "#F6F4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2324 10.5204L16.3493 36.4688C15.7935 36.8131 15.6225 37.5421 15.9672 38.0972L42.5102 80.84C42.8549 81.3951 43.5849 81.5659 44.1406 81.2216L86.0238 55.2733C86.5795 54.929 86.7506 54.1999 86.4059 53.6448L59.8628 10.9021C59.5181 10.347 58.7881 10.1761 58.2324 10.5204Z",
    stroke: "#F6F4EF",
    strokeWidth: 0.380903,
    strokeMiterlimit: 10
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8199 48.1384L45.46 62.0311C44.382 62.7274 43.0721 62.9699 41.8158 62.7059C40.5595 62.4419 39.4586 61.6927 38.7529 60.6216L29.8316 46.259C29.1794 45.1508 28.9933 43.8297 29.3141 42.5848C29.6348 41.3399 30.4362 40.2726 31.5429 39.6164L53.9271 25.7237C55.0051 25.0274 56.315 24.7848 57.5713 25.0489C58.8276 25.3129 59.9285 26.0621 60.6342 27.1332L69.5555 41.4958C70.2056 42.6069 70.388 43.9302 70.0626 45.1755C69.7372 46.4207 68.9307 47.4863 67.8199 48.1384Z",
    fill: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8199 48.1384L45.46 62.0311C44.382 62.7274 43.0721 62.9699 41.8158 62.7059C40.5595 62.4419 39.4586 61.6927 38.7529 60.6216L29.8316 46.259C29.1794 45.1508 28.9933 43.8297 29.3141 42.5848C29.6348 41.3399 30.4362 40.2726 31.5429 39.6164L53.9271 25.7237C55.0051 25.0274 56.315 24.7848 57.5713 25.0489C58.8276 25.3129 59.9285 26.0621 60.6342 27.1332L69.5555 41.4958C70.2056 42.6069 70.388 43.9302 70.0626 45.1755C69.7372 46.4207 68.9307 47.4863 67.8199 48.1384Z",
    stroke: "#572148",
    strokeWidth: 0.440419,
    strokeMiterlimit: 10
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6761 118.444L58.2983 137.457C58.2983 137.457 56.1978 144.01 63.059 143.022L84.9566 127.922C84.9566 127.922 78.9145 126.829 76.6761 118.444Z",
    fill: "url(#paint3_radial_692_38)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9514 128.231C100.309 125.688 103.3 118.232 100.631 111.579C97.9631 104.925 90.6463 101.594 84.2888 104.138C77.9312 106.681 74.9405 114.137 77.6088 120.79C80.2771 127.444 87.5939 130.775 93.9514 128.231Z",
    fill: "url(#paint4_radial_692_38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9514 128.231C100.309 125.688 103.3 118.232 100.631 111.579C97.9631 104.925 90.6463 101.594 84.2888 104.138C77.9312 106.681 74.9405 114.137 77.6088 120.79C80.2771 127.444 87.5939 130.775 93.9514 128.231Z",
    stroke: "#572148",
    strokeWidth: 0.291629,
    strokeMiterlimit: 10
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.702 205.503L300.129 197.945L298.783 197.467C298.053 197.212 297.38 196.816 296.803 196.302C296.227 195.787 295.757 195.164 295.422 194.468C295.087 193.772 294.892 193.017 294.85 192.246C294.807 191.474 294.917 190.702 295.174 189.974L300.632 174.445C300.888 173.716 301.285 173.045 301.8 172.47C302.316 171.895 302.94 171.427 303.636 171.093C304.333 170.759 305.089 170.565 305.861 170.523C306.632 170.481 307.405 170.592 308.134 170.848L331.053 178.884C332.525 179.402 333.732 180.481 334.408 181.886C335.085 183.29 335.176 184.905 334.663 186.377L329.204 201.906C328.949 202.635 328.552 203.306 328.036 203.881C327.521 204.456 326.897 204.924 326.2 205.258C325.503 205.592 324.747 205.786 323.976 205.828C323.204 205.87 322.431 205.759 321.702 205.503Z",
    fill: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.702 205.503L300.129 197.945L298.783 197.467C298.053 197.212 297.38 196.816 296.803 196.302C296.227 195.787 295.757 195.164 295.422 194.468C295.087 193.772 294.892 193.017 294.85 192.246C294.807 191.474 294.917 190.702 295.174 189.974L300.632 174.445C300.888 173.716 301.285 173.045 301.8 172.47C302.316 171.895 302.94 171.427 303.636 171.093C304.333 170.759 305.089 170.565 305.861 170.523C306.632 170.481 307.405 170.592 308.134 170.848L331.053 178.884C332.525 179.402 333.732 180.481 334.408 181.886C335.085 183.29 335.176 184.905 334.663 186.377L329.204 201.906C328.949 202.635 328.552 203.306 328.036 203.881C327.521 204.456 326.897 204.924 326.2 205.258C325.503 205.592 324.747 205.786 323.976 205.828C323.204 205.87 322.431 205.759 321.702 205.503Z",
    stroke: "#572148",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.725 215.977L346.455 239.396C346.022 240.495 345.375 241.497 344.553 242.345C343.731 243.194 342.75 243.872 341.665 244.342C340.581 244.811 339.414 245.063 338.232 245.081C337.05 245.1 335.876 244.886 334.777 244.451L316.934 237.428C316.934 237.428 306.732 244.313 295.239 239.777C295.239 239.777 304.096 234.609 303.82 232.243L300.17 230.801C299.07 230.369 298.066 229.724 297.216 228.903C296.366 228.082 295.686 227.102 295.216 226.018C294.746 224.934 294.494 223.769 294.476 222.588C294.458 221.407 294.673 220.234 295.11 219.136L304.371 195.709C304.806 194.61 305.453 193.608 306.276 192.759C307.099 191.911 308.081 191.232 309.166 190.763C310.252 190.293 311.419 190.042 312.601 190.024C313.784 190.005 314.959 190.219 316.058 190.654L350.632 204.304C351.736 204.734 352.743 205.378 353.597 206.198C354.451 207.018 355.134 207.999 355.607 209.084C356.08 210.168 356.334 211.335 356.355 212.518C356.375 213.701 356.161 214.877 355.725 215.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.725 215.977L346.455 239.396C346.022 240.495 345.375 241.497 344.553 242.345C343.731 243.194 342.75 243.872 341.665 244.342C340.581 244.811 339.414 245.063 338.232 245.081C337.05 245.1 335.876 244.886 334.777 244.451L316.934 237.428C316.934 237.428 306.732 244.313 295.239 239.777C295.239 239.777 304.096 234.609 303.82 232.243L300.17 230.801C299.07 230.369 298.066 229.724 297.216 228.903C296.366 228.082 295.686 227.102 295.216 226.018C294.746 224.934 294.494 223.769 294.476 222.588C294.458 221.407 294.673 220.234 295.11 219.136L304.371 195.709C304.806 194.61 305.453 193.608 306.276 192.759C307.099 191.911 308.081 191.232 309.166 190.763C310.252 190.293 311.419 190.042 312.601 190.024C313.784 190.005 314.959 190.219 316.058 190.654L350.632 204.304C351.736 204.734 352.743 205.378 353.597 206.198C354.451 207.018 355.134 207.999 355.607 209.084C356.08 210.168 356.334 211.335 356.355 212.518C356.375 213.701 356.161 214.877 355.725 215.977Z",
    stroke: "#572148",
    strokeWidth: 0.440419,
    strokeMiterlimit: 10
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.877 216.253C318.271 216.253 319.4 215.125 319.4 213.733C319.4 212.342 318.271 211.214 316.877 211.214C315.484 211.214 314.355 212.342 314.355 213.733C314.355 215.125 315.484 216.253 316.877 216.253Z",
    fill: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.15 213.733C319.15 214.986 318.133 216.003 316.877 216.003C315.622 216.003 314.605 214.986 314.605 213.733C314.605 212.48 315.622 211.464 316.877 211.464C318.133 211.464 319.15 212.48 319.15 213.733Z",
    stroke: "#572148",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.297 217.346C328.297 218.599 327.28 219.615 326.025 219.615C324.77 219.615 323.753 218.599 323.753 217.346C323.753 216.093 324.77 215.077 326.025 215.077C327.28 215.077 328.297 216.093 328.297 217.346Z",
    fill: "#BCDCFF",
    stroke: "#572148",
    strokeWidth: 0.5
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0729 207.624L12.3035 220.392C6.81507 221.627 3.3677 227.071 4.60356 232.553L14.178 275.023C15.4139 280.505 20.8649 283.948 26.3533 282.714L83.1228 269.946C88.6112 268.711 92.0585 263.267 90.8227 257.785L81.2482 215.315C80.0124 209.833 74.5613 206.39 69.0729 207.624Z",
    fill: "#F6F4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0729 207.624L12.3035 220.392C6.81507 221.627 3.3677 227.071 4.60356 232.553L14.178 275.023C15.4139 280.505 20.8649 283.948 26.3533 282.714L83.1228 269.946C88.6112 268.711 92.0585 263.267 90.8227 257.785L81.2482 215.315C80.0124 209.833 74.5613 206.39 69.0729 207.624Z",
    stroke: "#572148",
    strokeWidth: 0.499935,
    strokeMiterlimit: 10
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8117 213.92C17.6828 213.349 17.1143 212.989 16.5419 213.118C15.9694 213.247 15.6099 213.815 15.7388 214.387L17.1106 220.472C17.2395 221.044 17.8081 221.403 18.3805 221.274C18.9529 221.145 19.3125 220.577 19.1836 220.006L17.8117 213.92Z",
    fill: "#572148"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3442 210.871C31.2153 210.299 30.6468 209.94 30.0743 210.068C29.5019 210.197 29.1423 210.765 29.2712 211.337L30.6431 217.422C30.772 217.994 31.3405 218.353 31.913 218.224C32.4854 218.095 32.845 217.527 32.7161 216.956L31.3442 210.871Z",
    fill: "#572148"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1467 207.543C46.0178 206.971 45.4493 206.612 44.8768 206.741C44.3044 206.869 43.9448 207.437 44.0737 208.009L45.4456 214.094C45.5745 214.666 46.143 215.025 46.7155 214.896C47.2879 214.768 47.6474 214.2 47.5185 213.628L46.1467 207.543Z",
    fill: "#572148"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6196 204.515C59.4907 203.943 58.9222 203.584 58.3497 203.713C57.7773 203.841 57.4177 204.409 57.5466 204.981L58.9185 211.066C59.0474 211.638 59.6159 211.997 60.1883 211.868C60.7608 211.74 61.1203 211.172 60.9914 210.6L59.6196 204.515Z",
    fill: "#572148"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8012 238.189L18.7612 251.677L22.5325 268.688C22.5757 268.889 22.6584 269.08 22.7758 269.249C22.8932 269.418 23.0429 269.562 23.2164 269.672C23.3899 269.783 23.5836 269.859 23.7864 269.894C23.9892 269.929 24.197 269.924 24.3978 269.879L81.4533 257.048C81.6531 257.003 81.8421 256.919 82.0094 256.801C82.1767 256.683 82.3191 256.533 82.4283 256.36C82.5376 256.187 82.6116 255.994 82.646 255.792C82.6805 255.59 82.6748 255.384 82.6293 255.184L78.8012 238.189Z",
    stroke: "#572148",
    strokeWidth: 0.124984,
    strokeMiterlimit: 10,
    shapeRendering: "crispEdges"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5223 223.206L32.6818 227.893L41.2906 266.079L62.1311 261.392L53.5223 223.206Z",
    stroke: "#572148",
    strokeWidth: 0.154742,
    strokeMiterlimit: 10,
    shapeRendering: "crispEdges"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2367 240.036C41.7121 240.302 43.0264 241.13 43.9025 242.345C43.9025 242.345 46.8628 228.955 51.2666 227.966",
    stroke: "#572148",
    strokeWidth: 1.99379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0305 218.823L15.6281 231.734C14.8809 231.902 14.4116 232.643 14.5798 233.389L22.5793 268.873C22.7475 269.619 23.4897 270.088 24.2369 269.92L81.6393 257.01C82.3866 256.842 82.8559 256.1 82.6877 255.354L74.6882 219.87C74.5199 219.124 73.7778 218.655 73.0305 218.823Z",
    stroke: "#572148",
    strokeWidth: 0.249968,
    strokeMiterlimit: 10,
    shapeRendering: "crispEdges"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0419 25.2132C27.0419 25.2132 31.1375 15.0711 44.8844 14.1233",
    stroke: "#572148",
    strokeWidth: 0.940354,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2427 23.4146C21.2427 23.4146 26.8793 9.46516 45.8167 8.12854",
    stroke: "#572148",
    strokeWidth: 1.29745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3005 21.349C14.3005 21.349 21.8106 2.71735 47.0577 1",
    stroke: "#572148",
    strokeWidth: 1.72597,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.862 41.5033L365.774 46.9551L365.587 52.9091C365.587 52.9091 360.34 52.2935 360.097 57.4617C360.097 57.4617 359.781 61.1394 364.785 61.666L364.322 68.9566C364.322 68.9566 359.416 68.3167 358.921 73.2986C358.426 78.2806 363.649 78.0213 363.649 78.0213L363.244 83.5622L287.129 78.1672L287.559 72.0754C288.184 72.2338 288.836 72.2496 289.468 72.1215C290.1 71.9935 290.694 71.7249 291.208 71.3357C291.721 70.9466 292.14 70.4469 292.434 69.8737C292.728 69.3006 292.888 68.6687 292.904 68.0251C292.904 68.0251 293.147 64.161 288.2 63.3914L288.703 56.1008C288.703 56.1008 293.625 57 294.12 51.4834C294.12 51.4834 294.12 48.0163 289.457 47.3682L289.862 41.5033Z",
    fill: "#DEF6E9",
    stroke: "#572148",
    strokeWidth: 0.321387,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.959 46.6798L297.907 74.4653L352.789 78.5643L354.954 50.074L299.959 46.6798Z",
    fill: "#FFFFFE",
    stroke: "#572148",
    strokeWidth: 0.321387,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.348 51.8237L350.146 21.1705L352.773 26.76C352.773 26.76 347.623 28.6637 349.837 33.5565C349.837 33.5565 351.281 37.1047 356.155 35.2415L359.172 42.2162C359.172 42.2162 354.306 43.9255 356.22 48.7778C358.134 53.6301 362.822 50.9164 362.822 50.9164L365.06 56.2305L292.068 87.0132L289.595 81.1726C289.595 81.1726 294.461 79.9656 292.628 74.9188C292.628 74.9188 291.006 71.233 286.099 72.845L283.123 65.8541C283.123 65.8541 288.102 64.3798 285.961 59.0414C285.961 59.0414 284.339 55.8011 279.7 57.4213L277.348 51.8237Z",
    fill: "#DEF6E9",
    stroke: "#572148",
    strokeWidth: 0.33329,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.124 51.856L300.316 78.5317L353.033 56.522L341.597 29.1497L289.124 51.856Z",
    fill: "#FFFFFE",
    stroke: "#572148",
    strokeWidth: 0.33329,
    strokeMiterlimit: 10
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1162 39.5917L43.311 39.7051C43.0761 39.7089 42.8464 39.7747 42.6453 39.8959C42.4442 40.017 42.2787 40.1893 42.1659 40.395C42.053 40.6008 41.9967 40.8327 42.0026 41.0672C42.0086 41.3018 42.0766 41.5305 42.1999 41.7303L47.5526 50.3576C47.6766 50.5587 47.8521 50.7232 48.061 50.8341C48.2699 50.9449 48.5046 50.9982 48.7409 50.9883C48.9772 50.9784 49.2066 50.9057 49.4055 50.7777C49.6043 50.6498 49.7654 50.4712 49.8721 50.2604L54.3165 41.5197C54.4221 41.3164 54.4728 41.0892 54.4639 40.8604C54.455 40.6316 54.3866 40.409 54.2656 40.2146C54.1445 40.0201 53.9749 39.8605 53.7734 39.7513C53.5719 39.6421 53.3454 39.5871 53.1162 39.5917Z",
    fill: "#F6F4EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1162 39.5917L43.311 39.7051C43.0761 39.7089 42.8464 39.7747 42.6453 39.8959C42.4442 40.017 42.2787 40.1893 42.1659 40.395C42.053 40.6008 41.9967 40.8327 42.0026 41.0672C42.0086 41.3018 42.0766 41.5305 42.1999 41.7303L47.5526 50.3576C47.6766 50.5587 47.8521 50.7232 48.061 50.8341C48.2699 50.9449 48.5046 50.9982 48.7409 50.9883C48.9772 50.9784 49.2066 50.9057 49.4055 50.7777C49.6043 50.6498 49.7654 50.4712 49.8721 50.2604L54.3165 41.5197C54.4221 41.3164 54.4728 41.0892 54.4639 40.8604C54.455 40.6316 54.3866 40.409 54.2656 40.2146C54.1445 40.0201 53.9749 39.8605 53.7734 39.7513C53.5719 39.6421 53.3454 39.5871 53.1162 39.5917Z",
    stroke: "#572148",
    strokeWidth: 0.499935,
    strokeMiterlimit: 10
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_692_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.905 234.017C90.4924 233.873 91.1078 233.81 91.7104 233.761C92.0518 233.734 92.3925 233.715 92.7348 233.699C93.225 233.677 93.7137 233.66 94.2042 233.649C95.1385 233.629 96.073 233.621 97.0073 233.618C98.8801 233.612 100.751 233.601 102.622 233.516C104.562 233.428 106.502 233.347 108.442 233.257C110.281 233.172 112.12 233.086 113.96 233.021C115.803 232.955 117.644 232.897 119.485 232.789C121.369 232.68 123.254 232.621 125.141 232.573C126.036 232.55 126.933 232.521 127.824 232.432C128.289 232.386 128.753 232.334 129.216 232.279C129.671 232.225 130.127 232.19 130.583 232.15C131.004 232.113 131.419 232.126 131.84 232.154C132.14 232.123 132.368 231.985 132.525 231.739C132.609 231.584 132.692 231.429 132.776 231.274C132.93 230.863 133.004 230.439 133 230.004C133.004 229.569 132.93 229.145 132.776 228.734C132.692 228.579 132.609 228.424 132.525 228.269C132.368 228.023 132.14 227.885 131.84 227.854C131.608 227.871 131.377 227.894 131.145 227.908C130.934 227.922 130.723 227.921 130.512 227.922C130.06 227.925 129.609 227.94 129.158 227.957C128.221 227.993 127.286 228.051 126.348 228.077C124.532 228.127 122.714 228.132 120.9 228.23C119.927 228.283 118.955 228.344 117.983 228.395C117.099 228.442 116.214 228.473 115.33 228.503C113.447 228.568 111.566 228.648 109.685 228.739C107.828 228.83 105.97 228.914 104.113 229.006C103.086 229.057 102.059 229.103 101.032 229.146C100.112 229.185 99.1893 229.19 98.2686 229.199C96.3832 229.217 94.4979 229.23 92.615 229.333C92.1514 229.359 91.6883 229.393 91.2268 229.444C90.8518 229.485 90.4768 229.542 90.1076 229.615C89.8221 229.672 89.5466 229.76 89.2696 229.845C89.1084 229.894 88.9501 229.97 88.8098 230.058C88.5323 230.262 88.34 230.522 88.233 230.838C87.9807 231.447 87.9471 232.175 88.0661 232.812C88.1254 233.196 88.2659 233.553 88.4874 233.88C88.5946 233.984 88.7023 234.087 88.8098 234.19C89.0572 234.338 89.3049 234.338 89.5524 234.19C89.6631 234.12 89.7818 234.063 89.905 234.017Z",
    fill: "#FFDBA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.131 260.537C247.189 260.497 247.437 260.344 247.641 260.202C248.924 259.367 251.024 257.19 251.665 256.051C251.768 255.878 251.986 255.44 252 255.206C252 254.982 251.928 254.769 251.782 254.565C251.578 254.311 251.257 254.107 250.878 253.996C250.615 253.924 249.828 253.812 249.814 253.812C248.953 253.701 247.554 253.639 246.008 253.639C244.535 253.639 243.193 253.701 242.319 253.792C242.305 253.802 241.327 253.914 240.992 254.036C240.38 254.26 240 254.698 240 255.166V255.206C240.015 255.511 240.395 256.152 240.409 256.152C241.051 257.231 243.048 259.357 244.375 260.212C244.375 260.212 244.716 260.453 244.929 260.557C245.235 260.721 245.614 260.802 245.993 260.802C246.416 260.802 246.81 260.71 247.131 260.537Z",
    fill: "#572148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_692_38",
    x: 26.1229,
    y: 132.88,
    width: 12.12,
    height: 12.1152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_692_38",
    x: 271.911,
    y: 31.6533,
    width: 13.4338,
    height: 13.4275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_692_38",
    x: 95.4084,
    y: 100.55,
    width: 13.9043,
    height: 13.8973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_692_38",
    x: 279.292,
    y: 114.58,
    width: 11.7793,
    height: 11.7749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_692_38",
    x: 137.336,
    y: 262.596,
    width: 17.9474,
    height: 18.1796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_692_38",
    x: 271.479,
    y: 140.781,
    width: 23.4288,
    height: 23.4109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_692_38",
    x: 268.2,
    y: 137.105,
    width: 30.1772,
    height: 44.729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_692_38",
    x: 31.3051,
    y: 172.104,
    width: 18.6731,
    height: 18.6605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_692_38",
    x: 28.8861,
    y: 169.565,
    width: 23.3492,
    height: 33.1061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_692_38",
    x: 99.5776,
    y: 18.4896,
    width: 15.3804,
    height: 15.3717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_692_38",
    x: 97.9458,
    y: 16.7295,
    width: 18.6442,
    height: 25.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_692_38",
    x: 63.5082,
    y: 221.918,
    width: 31.1964,
    height: 31.1692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_692_38",
    x: 67.5072,
    y: 225.915,
    width: 23.1986,
    height: 23.1808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_692_38",
    x: 82.3672,
    y: 319.383,
    width: 8.31628,
    height: 8.99646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_692_38",
    x: 280.801,
    y: 319.383,
    width: 8.34058,
    height: 8.99646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_692_38",
    x: 82.0924,
    y: 281.771,
    width: 207.307,
    height: 57.9646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_692_38",
    x: 94.4032,
    y: 283.877,
    width: 184.981,
    height: 26.7289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_692_38",
    x: 55.5404,
    y: 2.16589,
    width: 227.852,
    height: 332.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_692_38",
    transform: "scale(0.00487805 0.0120482)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_692_38",
    x: 10.3807,
    y: 8.57385,
    width: 82.5137,
    height: 82.5405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_692_38",
    x: 11.5986,
    y: 10.1522,
    width: 79.1758,
    height: 79.4376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_692_38",
    x: 24.9403,
    y: 24.7245,
    width: 49.5002,
    height: 46.3058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_692_38",
    x: 53.9954,
    y: 118.444,
    width: 34.9613,
    height: 32.6791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_692_38",
    x: 72.4871,
    y: 103.138,
    width: 33.266,
    height: 34.0934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_692_38",
    x: 290.591,
    y: 170.265,
    width: 48.6501,
    height: 43.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_692_38",
    x: 290.255,
    y: 189.802,
    width: 70.3213,
    height: 63.5004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_692_38",
    x: 310.355,
    y: 211.214,
    width: 13.0447,
    height: 13.0387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_692_38",
    x: 0.102417,
    y: 207.123,
    width: 95.2213,
    height: 84.0916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_692_38",
    x: 11.7125,
    y: 213.092,
    width: 11.4972,
    height: 16.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_692_38",
    x: 25.245,
    y: 210.042,
    width: 11.4972,
    height: 16.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_692_38",
    x: 40.0475,
    y: 206.714,
    width: 11.4972,
    height: 16.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_692_38",
    x: 53.5204,
    y: 203.686,
    width: 11.4972,
    height: 16.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_692_38",
    x: 14.6868,
    y: 238.114,
    width: 72.0439,
    height: 39.8654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_692_38",
    x: 28.5892,
    y: 223.113,
    width: 37.6344,
    height: 51.0588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_692_38",
    x: 35.2396,
    y: 226.969,
    width: 21.024,
    height: 24.3727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_692_38",
    x: 10.4207,
    y: 218.664,
    width: 76.4261,
    height: 59.4153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_692_38",
    x: 22.5715,
    y: 13.6531,
    width: 26.7831,
    height: 20.0304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_692_38",
    x: 16.5938,
    y: 7.47974,
    width: 33.8717,
    height: 24.5837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_692_38",
    x: 9.43738,
    y: 0.136963,
    width: 42.4834,
    height: 30.0753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_692_38",
    x: 273.13,
    y: 20.9548,
    width: 96.8094,
    height: 74.2766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_692_38",
    x: 37.7522,
    y: 39.3414,
    width: 20.9626,
    height: 19.8979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_692_38",
    x: 84,
    y: 227.854,
    width: 172,
    height: 40.9473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_692_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_692_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_692_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.064 88.0927) rotate(90) scale(172.957 207.131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FB5850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A53732"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_692_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.749 203.139) rotate(90) scale(71.679 55.7651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FB5850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A53732"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_692_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.007 208.32) rotate(90) scale(75.8348 63.0533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FB5850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A53732"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_692_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.1751 141.313) rotate(-21.672) scale(30.7848 30.7586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#572148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#002148"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_692_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.312 115.764) rotate(132.666) scale(8.67455 12.9568)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB8B5"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_692_38",
    width: 205,
    height: 83,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAABTCAYAAAA80INaAAAACXBIWXMAAAsSAAALEgHS3X78AAAFUElEQVR4Xu2c23LjNhAFQSX//8ex8pDAHs3OlZIIaLe7igUQGIK0eNqi5bKP+/0+AKDOLSsAgEeQBqAJ0gA0QRqAJkgD0ARpAJogDUATpAFogjQATZAGoAnSADRBGoAmSAPQBGkAmiANQBOkAWiCNABNkAagCdIANEEagCZIA9AEaQCaIA1AE6QBaII0AE2QBqDJ31kB/HAcx5HVfCp3/j9xmeN3fa3eGPB3rbuSt4TgdxXxI6VpCFGtq2Kt9+pzXIF1018dhNJ6nyjW1tIEclSC+o6A6+OfXW8l+sY/G4SzIpo1O8u0nTSGKFn4q2KdCXi2RnZtu1AJdLZfobqGHE+vbTeBtpFGyXKo1hvzarK6aMxDn7+y/m54odZthTTsaj8SJbqO7/4u8iyXJpDFCmkU3EiwZwJeXbez5iqsMIZBLXBKAKfO63+3O4iz00fOh7Fl42da3ffwRNPXped3Roc2Cri1b5GJUG29TXI/juNYLc5SacS7jJbiluyPpB+NTbKQR9JE61r7K/FEiL6r61qPTJhsTPe/nP7DeVaLs0yaRJib09e1VXGq0nhh99aVY7pv7V9JJEAWbAtrPFqzIozevsaPLIfof41HlgkzxkJp/scTxtsieYbTtwIv20kU8Io01vE7SSPHzkhjzXnHWuJ4wkgxbuNHnPnayfHv8698t1ktjcQS5y+1L+WR9UONRftDtLpvkUl3Zs0rkcGKQm61Ht6amTRzXz96fY1fZZnHzXp5/+Tc5SyRxvldjBahI04kTCSNdR0eZ2Sx1nuHUFaA9FhHHgtvvUwaa+w2fmS5D1+IWS/v5TJZJkukUXjhl1skjfVOo0WxxiZZiL3aw2l139p/J2dkifoWurYqyxyTj1re9VkyPbDqEW0HaTx02OeYnte11ph3jGwjquJ4Y3ruHczwyHPM4Mm5u2pH0M/Qx41hn18ix+S1zX2L6vVcwi7SRN+Z9Jyuz+iEoIIVsCyUV6BfD+s1s2q94yK8+2HdR2s+qrfOX7mmy1gizf1+v4ufa3QI9TY/bpxBnI9j87j5qDZror4ek62kEnZZ461p1Xj7Z4gCbwXbq4mIQuxJMZK+/n1MtFnX/d/AgkezMRZJY+CJMudmK3+AnMLIT1wq0oygzYgEy1rdfzUdYSIRMqI1q9Jk4vyj5qPrvpzV0ugbLWWR41OY+Zn9YWzD6FtjmTCdYFtCvPocGTpIXph1bSeA3XNU5rU8svXecbRES1gmjXpEG+PnhZji6Bc2+pjZC2klyFaAO6HO1n2nOJUwR20FqzZaNzunDr++z1IcOfZwHasezcZYKI3A+uLnI9d8sQ4xpgXIQpq1ul/FOj5rdf9VyNewElpd2+HMuTxxZF+LE21L2elPA7QIehtJf9IJs+530Md5X4eefyc60JEw1n6Vjjhe3xNH7//ydax8lxljA2nGGNbf1ERhz4JfCbM1f5aKpLr/Liph1v0zePJV5KwI5M0tF2aMTaSZGO86Z/qV+az+DO+Ws0I3zF2s46uCZPNhfwdZJltJMznxfwK8Gm/uVQHO1q1c9yvIwlnZP0tn3Urtw9hOsky2lEZiCPQwHcxJrgpvRZqrqAT0WdLQB7h1O4oi2V4aj0Qmi279Ga6SM+OZMD9D6xy7y+HxsdJ0OCHYM1x5riqX3eRPFaHDHyHNVVwsZ4s/IcxXgTQATW4DAFogDUATpAFogjQATZAGoAnSADRBGoAmSAPQBGkAmiANQBOkAWiCNABNkAagCdIANEEagCZIA9AEaQCaIA1AE6QBaII0AE2QBqAJ0gA0QRqAJkgD0ARpAJogDUCTfwHZIbl74t/cVAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctopus);
export default __webpack_public_path__ + "static/media/Octopus.e55659ec12a0d770b84c89fbb756a71c.svg";
export { ForwardRef as ReactComponent };